const ChatsView = () => {
  return <div>ChatsView</div>;
};

export default ChatsView;
